import { calculateGuidedYAxisMax, calculateGuidedYAxisTicks } from './barChartAxisScale';

type StackedYAxisScale = {
  max: number;
  ticks: number[];
};

const normaliseStackedYAxisNumber = (value: number): number => Number(value.toPrecision(12));

const resolveStackedYAxisHeadroomTickCount = (headroomTicks: number): number => {
  if (!Number.isFinite(headroomTicks) || headroomTicks <= 0) return 0;
  return Math.floor(headroomTicks);
};

export const buildStackedYAxisScale = (
  stackedValueMax: number,
  headroomTicks: number,
): StackedYAxisScale => {
  const baseMax = calculateGuidedYAxisMax(stackedValueMax, true);
  const baseTicks = calculateGuidedYAxisTicks(0, baseMax, true);
  const resolvedHeadroomTicks = resolveStackedYAxisHeadroomTickCount(headroomTicks);

  if (resolvedHeadroomTicks === 0 || stackedValueMax <= 0 || baseMax > stackedValueMax) {
    return { max: baseMax, ticks: baseTicks };
  }

  if (baseTicks.length < 2) {
    return { max: baseMax, ticks: baseTicks };
  }

  const topTick = baseTicks[baseTicks.length - 1];
  const previousTick = baseTicks[baseTicks.length - 2];
  if (typeof topTick !== 'number' || typeof previousTick !== 'number') {
    return { max: baseMax, ticks: baseTicks };
  }

  const step = topTick - previousTick;
  if (!Number.isFinite(step) || step <= 0) {
    return { max: baseMax, ticks: baseTicks };
  }

  const ticks = [...baseTicks];
  for (let index = 0; index < resolvedHeadroomTicks; index += 1) {
    const currentTopTick = ticks[ticks.length - 1];
    if (typeof currentTopTick !== 'number') break;
    ticks.push(normaliseStackedYAxisNumber(currentTopTick + step));
  }

  const resolvedMax = ticks[ticks.length - 1];
  return { max: typeof resolvedMax === 'number' ? resolvedMax : baseMax, ticks };
};
